<template>
<!-- eslint-disable vue/valid-v-slot -->
  <v-container fluid>
    <printHeader class="d-none d-print-flex" ></printHeader>
    <v-data-table
    :headers="headers"
    :items="transData"
    :loading="dataLoading"
    fixed-header
    hide-default-header
    hide-default-footer
    :expanded.sync="expanded"
    show-expand
    :no-data-text="$t('No Data Available')"
    :items-per-page="itemsPerPage"
    :page.sync="page"
    @page-count="pageCount = $event"
    :search="filterFeedCode || filterType"
    :custom-filter="filterFeed"
    >
      <template v-slot:top>
        <v-toolbar flat  color="secondary darken-1" height="140px" >
          <v-layout wrap class="ma-0">
            <v-row align="start" class="pt-4">
              <v-col xs12 sm4 class="my-0  py-0">
                <v-toolbar-title class="pb-0 primary--text">{{$t('Inventory Transactions')}}</v-toolbar-title>
              </v-col>
              <v-col xs6 sm4 class="px-2 my-0 py-0">
                <PickDate v-model="fromDate" @input="fromDate=$event" :label="$t('From Date')"> </PickDate>
              </v-col>
              <v-col xs6 sm4 class="px-2 my-0 py-0">
                <PickDate v-model="toDate" @input="toDate=$event" :label="$t('To Date')"> </PickDate>
              </v-col>
            </v-row>
            <v-row class="my-0 py-0" justify="end">
            <v-col xs12 sm4 class="my-0  py-0">
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn icon large color="primary" v-on="on" class="ms-1 mt-0"
                    @click="csvExport">
                    <v-icon>mdi-microsoft-excel</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('Export report data to a file in Excel format')}}</span>
              </v-tooltip>
            </v-col>
            <v-col xs6 sm4 class="px-2 py-0">
              <v-select flat class="py-0" :items="dropdown_materials" v-model="filterFeedCode"
                :label="$t('Filter Feed')" editable item-value="code">
              </v-select>
            </v-col>
            <v-col xs6 sm4 class="px-2 py-0">
              <v-select flat class="py-0" :items="transTypes" v-model="filterType"
                :label="$t('Filter Type')" editable item-text="text" item-value="value">
              </v-select>
            </v-col>
            </v-row>
          </v-layout>
        </v-toolbar>
      </template>

      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th v-for="hdr in headers" :key="hdr.index"
              class="subtitle-2 font-weight-bold"
              :class="{'text-right': hdr.align == 'right', 'text-center': hdr.align == 'center'}" >
              {{hdr.text.toUpperCase()}}
            </th>

          </tr>
        </thead>
      </template>

      <template v-slot:expanded-item="{ item }">
        <td colspan="5">
          <v-container v-if="item.transType == 'production'" class="px-0">
            <v-row no-gutters>
                <span>{{$t('Inventory change due to production') +
                        (item.wagonName ? ", " + $t('wagon') + " " + item.wagonName : "")}}</span>
            </v-row>
          </v-container>
          <v-container v-if="item.transType == 'adjustment'" class="px-0">
            <v-row no-gutters>
                <span v-if="item.reference == 'RESET_QTY'">{{$t('Adjustment made during stock reset')}}</span>
                <span v-else>{{$t('Adjustment made during stocktacking') + " " + item.reference}}</span>
            </v-row>
          </v-container>
          <v-container v-if="item.transType == 'purchase'" class="px-0">
            <v-row no-gutters>
              <v-col cols="12" sm="4" offset-md="1">
                <span class="detail_label">{{$t('Seller')}}:</span> <span class="detail_value">{{item.seller}}</span>
              </v-col>
              <v-col cols="12" sm="6">
                <span class="detail_label">{{$t('Reference')}}:</span> <span class="detail_value"> {{item.reference}}</span>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="4" offset-md="1">
                <span class="detail_label">{{$t('Driver')}}:</span> <span class="detail_value"> {{item.driver}}</span>
              </v-col>
              <v-col cols="12" sm="6">
                <span class="detail_label">{{$t('truck no')}}:</span> <span class="detail_value"> {{item.truckNo}}</span>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" sm="4" offset-md="1">
                <span class="detail_label">{{$t('Total Price')}}:</span> <span class="detail_value"> {{ formatValue(item.feedValue * item.transQty) }}</span>
              </v-col>
              <v-col cols="12" sm="6">
                <span class="detail_label">{{$t('Dry Material')}}:</span> <span class="detail_value"> {{item.dryMaterial | percentValue}}</span>
              </v-col>
            </v-row>
          </v-container>
        </td>
      </template>

      <template v-slot:item.transTime="{ item }">
        <span class="ps-1">{{item.transTime | dateTimeString}}</span>
      </template>


      <template v-slot:item.transQty="{ item }">
        <span>{{item.transQty | kgString}}</span>
      </template>

    </v-data-table>
    <v-layout class="text-center pt-4">
    <v-flex sx12 sm3>
      <v-select
        :items="perPageList"
        :label="$t('Items per page')"
        :value="itemsPerPage"
        @input="itemsPerPage = parseInt($event, 10)"
        type="number"
        class="my-0 ml-1 mr-0 py-0"
      ></v-select>
    </v-flex>
    <v-flex xs12 sm9>
    <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import PickDate from "../components/common/PickDate";
import getter from "../store/reportGetters";
import printHeader from "../components/common/PrintHeader";
import moment from "moment";

export default {
  name:"ReportTransaction",
  components: {
     "PickDate": PickDate,
     "printHeader": printHeader
  },
  data() {
    return {
      fromDate: "",
      toDate: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 25,
      filterFeedCode: "",
      filterType: "",
      dataLoading: true,
      transTypes: [
          {text: this.$i18n.t('Show All'), value: "" },
          {text: this.$i18n.t('Productions'), value: "production" },
          {text: this.$i18n.t('Purchases'), value: "purchase" },
          {text: this.$i18n.t('Adjustments'), value: "adjustment" }
          ],
      perPageList: [
        {text: "10", value: 10 },
        {text: "25", value: 25 },
        {text: "50", value: 50 },
        {text: "100", value: 100 },
        {text: "1000", value: 1000 },
      ],
      expanded: [],
      headers: [
        { text: '', value: 'data-table-expand' },
        { text: this.$i18n.t('Transaction Time'), width: "12%", align: "left", value: "transTime"},
        { text: this.$i18n.t('Code'), width: "10%", align: "left", value: "materialCode"},
        { text: this.$i18n.t('Name'), width: "15%", align: "left", value: "materialName"},
        { text: this.$i18n.t('Qty'), width: "10%", align: "right", value: "transQty"},
        { text: this.$i18n.t('Reference'), width: "18%", align: "right", value: "reference"},
        { text: this.$i18n.t('Transaction Type'), width: "15%", align: "right", value: "transType"},
      ],
      transData: [],
    }
  },
  created() {
    let d = moment().startOf('month').add("day", 1).toDate();
    this.fromDate = d.toISOString().substr(0, 10)
    this.toDate = new Date().toISOString().substr(0, 10)
    //create list of materials
    this.dropdown_materials = this.$store.getters.getFeedsForDD
        .concat(this.$store.getters.getTMRs.map(function(x) {
          return {text: x.code + "-" + x.name, code: x.code +""}
        }) );
      //add "all" to top of list
    if (this.dropdown_materials.findIndex((x)=> x.code == "") == -1)
      this.dropdown_materials.unshift({text: this.$i18n.t('Show All'), code:""});

    this.loadTransactionData();
  },
  watch: {
    fromDate: function() {
      if (! this.dataLoading)
      this.loadTransactionData();
    },
    toDate: function() {
      if (! this.dataLoading)
      this.loadTransactionData();
    },
  },
  methods: {
    loadTransactionData: function() {
      this.dataLoading = true;
      getter.getTransactionLog(this.fromDate, this.toDate, this.$store.state).then((data) => {
        this.transData = data;
        this.dataLoading = false;
      });
    },
    filterFeed( value, search, item) {
      let _code = this.filterFeedCode;
      let _type = this.filterType;
      return item &&
        (_code == "" || item.materialCode == _code) &&
        (_type == "" || item.transType == _type)
    },
    formatValue(value) {
      const currency = this.$store.getters.getCurrency;
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency, currencyDisplay: 'symbol' }).format(value);
    },
    csvExport() {
      let separator = this.$store.getters.getSeparator;
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        [
          this.$i18n.t('Number'), this.$i18n.t('Code'), this.$i18n.t('Name'), this.$i18n.t('Qty'), this.$i18n.t('Transaction Time'),
          this.$i18n.t('Wagon'), this.$i18n.t('Transaction Type'), this.$i18n.t('Seller'), this.$i18n.t('Driver'),
          this.$i18n.t('truck no'), this.$i18n.t('Reference'), this.$i18n.t('Dry Material'), this.$i18n.t('Value')
        ].join(separator),
        ...this.transData.map(item => [
          item.transNo, item.materialCode, item.materialName, item.transQty, item.transTime,
          item.wagonName, item.transType, item.seller, item.driver, item.truckNo, item.reference,
          item.dryMaterial, item.feedValue
        ].join(separator))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "transactions.csv");
      link.click();
    }
  },
}
</script>

<style>
  .v-data-table td, .v-data-table th {
    padding: 0 4px;
  }
  .v-row-group__summary tr{
    margin-bottom: 10px !important;
    background-color: #1e1e1e !important;
    border-bottom-width: 3px;
  }
  .detail_label {
    color: rgba(255, 255, 255, 0.7);
    text-transform: uppercase;
    padding: 0 4px;
  }

</style>